import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { logger } from './services/logger';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'; // ✅ Ajouté ici
import 'leaflet/dist/leaflet.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* ✅ Ajouté ici */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();

window.addEventListener('unhandledrejection', (event) => {
  logger.error('Global', 'Unhandled promise rejection', {
    reason: event.reason?.message || String(event.reason),
    stack: event.reason?.stack || null,
  });
});

window.onerror = (message, source, lineno, colno, error) => {
  logger.error('Global', String(message), {
    source,
    lineno,
    colno,
    stack: error?.stack || null,
  });
  return false;
};

// Évite que le bouton physique Android quitte l'app quand l'historique est vide
if (window.history.length <= 1) {
  window.history.pushState(null, "", window.location.href);
}
window.addEventListener("popstate", () => {
  if (window.history.length <= 1) {
    window.history.pushState(null, "", window.location.href);
  }
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then(reg => console.log('✅ Service worker FCM enregistré :', reg.scope))
    .catch(err => console.warn('⚠️ Échec enregistrement SW FCM :', err));

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => console.log('✅ Service worker enregistré :', reg.scope))
      .catch(err => console.warn('⚠️ Échec enregistrement SW :', err));
  });
}
